import _ from 'lodash'
import fp from 'lodash/fp' // https://github.com/lodash/lodash/wiki/FP-Guide
import moment from 'moment'

class InvoicePaymentTableCtrl {
    /** @ngInject */
    constructor($filter, $window, PaymentStatus, PaymentModes, Invoice, Contract, ContractService, ErrorCatcher, ApiService) {
        this.$filter = $filter
        this.$window = $window
        this.PaymentModes = PaymentModes
        this.Invoice = Invoice
        this.Contract = Contract
        this.ContractService = ContractService
        this.PaymentStatus = PaymentStatus
        this.ErrorCatcher = ErrorCatcher
        this.ApiService = ApiService
        this.currentDate = new Date()
        this.paymentsData = []
        this.isRegularizing = false
    }

    $onInit() {
        this.ApiService.fetchUserInfo().then((userInfo) => {
            this.computedPaymentMode = userInfo.billingaccount.recurrent_cb_payment ? 'CB' : 'SEPA'
        })
        this.Invoice.getPayments({ id_contract: this.contract.id }).$promise.then((result) => {
            this.paymentsData = InvoicePaymentTableCtrl.transformPaymentsData(result)
        }).catch(this.ErrorCatcher.catchError)
    }

    static transformPaymentsData(data) {
        const plannedAndOtherPayments = _.partition(data, { status: 0 })
        const burnAndOtherPayments = _.partition(plannedAndOtherPayments[1], { type: 'BURN' })

        // Group burn payment with TT payment
        const burnPaymentByValueDate = _.keyBy(burnAndOtherPayments[0], (p) => moment(p.value_date).format('MM-YYYY'))
        const otherPaymentsWithBurnPayment = _.map(burnAndOtherPayments[1], (p) => {
            return _.assign({}, p, { burnPayment: p.type === 'TT' ? burnPaymentByValueDate[moment(p.value_date).format('MM-YYYY')] : undefined })
        })

        // Create datastructure for mobile view
        const burnMobilePayments = _.isEmpty(plannedAndOtherPayments[0]) ? null : ['Paiement programmé', plannedAndOtherPayments[0]]
        const otherMobilePayments = fp.flow(
            fp.groupBy((p) => moment(p.payment_date).startOf('month').toISOString()),
            fp.toPairs,
            (payments) => _.orderBy(payments, [(p) => p[0]], ['desc']),
            fp.map((p) => [_.capitalize(moment(p[0]).format('DD MMMM YYYY')), _.orderBy(p[1], ['payment_date'], ['desc'])]),
        )(otherPaymentsWithBurnPayment)

        return {
            desktopPayments: [plannedAndOtherPayments[0], otherPaymentsWithBurnPayment],
            mobilePayments: _.compact([burnMobilePayments].concat(otherMobilePayments)),
        }
    }

    // sumBy('1.23', '1.23') => 2.46
    sumBy(...args) {
        const encodeToCents = (number) => Number(number) * 100
        const decodeFromCents = (number) => Number(number) / 100
        return decodeFromCents(_.sumBy(args, encodeToCents))
    }

    getPaymentTypeLabel(payment) {
        const formattedValueDate = this.$filter('elision')(moment(payment.value_date).format('MMMM YYYY'))
        switch (payment.type) {
            case 'TT':
                return `Échéance ${formattedValueDate}`
            case 'REC':
                return `Régularisation ${formattedValueDate}`
            case 'REG':
                return `Facture de régularisation ${formattedValueDate}`
            case 'MISC':
                return 'Frais'
            case 'BURN':
                return 'Utilisation de la cagnotte'
            default:
                return 'Inconnu'
        }
    }

    getPaymentStatusLabel(payment) {
        if (payment.status <= 50 && payment.status <= 55) {
            const paymentDateDelay = payment.mode === 'CB' ? moment().add(-9, 'hours') : moment().add(-5, 'days')
            const paymentValidated = moment(payment.payment_date).isBefore(paymentDateDelay)
            return paymentValidated ? 'Payé' : 'En cours de traitement'
        }
        return _.get(this.PaymentStatus, payment.status, 'Inconnu')
    }

    getPaymentModeLabel(paymentMode) {
        return _.get(this.PaymentModes, paymentMode, 'Inconnu')
    }

    displayNegativeBalance() {
        return this.ContractService.isContractNegativeBalance(this.ContractService.NEGATIVE_BALANCE_THRESHOLD)(this.contract)
    }

    displayRegulateBtn() {
        return this.ContractService.isContractNegativeBalance(this.ContractService.REGULATE_BTN_THRESHOLD)(this.contract)
    }

    regulateByCreditCard() {
        this.$uibModal.open({
            animation: true,
            resolve: { unpaidContract: this.contract },
            component: 'unpaidBalanceModal',
        })
    }

    regularizeByCreditCard() {
        this.isRegularizing = true
        this.Contract.regularize({ id: this.contract.id }).$promise.then((result) => {
            this.$window.location = result.redirectUrl
        }).catch((error) => {
            this.isRegularizing = false
            this.ErrorCatcher.catchError(error)
            this.error = error
        })
    }
}

export default {
    template: require('./invoicePaymentTable.jade')(),
    controller: InvoicePaymentTableCtrl,
    bindings: {
        contract: '<',
    },
}



// WEBPACK FOOTER //
// ./src/states/invoice/component/invoicePaymentTable.js